import { NavDropdown } from "react-bootstrap";
import {
    DropdownItem,
} from './customDropdownStyle';
import { MESSAGE } from "../../../utils/message";

const NavDropdownItems = (props: any) => {

    return (
        <DropdownItem className={props.title === MESSAGE.aboutUs ? "border-left-white" : ""}>
            {props.data?.map((item: any, index: number) => <NavDropdown.Item href={item.url} key={index + 1}>{item.name}</NavDropdown.Item>)}
            {/* item.name === MESSAGE.communityConnect ?
             : <NavDropdown.Item onClick={() => navigate(item.url)}  key={index+1}>{item.name}</NavDropdown.Item>)} */}
        </DropdownItem>
    );
};
export default NavDropdownItems;